var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 595,
    height: 433,
    viewBox: "0 0 595 433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6795",
    "data-name": "Rectangle 6795",
    width: 595,
    height: 433,
    transform: "translate(845 60)",
    fill: "#f8f9f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.12,
    y1: 0.408,
    x2: -0.118,
    y2: 0.644,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe2c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb870"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -9.906,
    y1: 0.5,
    x2: -8.386,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8e8e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 51.364,
    y1: -147.436,
    x2: 50.421,
    y2: -147.436,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 30.25,
    y1: 0.5,
    x2: 29.25,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 30.73,
    y1: 196.022,
    x2: 29.917,
    y2: 196.022,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 3.923,
    y1: 59.457,
    x2: 3.005,
    y2: 59.457,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 29.813,
    y1: 198.675,
    x2: 29,
    y2: 198.675,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 42.125,
    y1: 305.167,
    x2: 41.291,
    y2: 305.167,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_28",
    "data-name": "Mask Group 28",
    transform: "translate(-845 -60)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17111",
    "data-name": "Group 17111",
    transform: "translate(852.824 84.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18974",
    "data-name": "Path 18974",
    d: "M260.258,258.971c-7.218,3.743-18.326,3.812-24.8.153L29.106,142.566c-6.471-3.666-5.863-9.657,1.359-13.4l29.424-15.24c7.225-3.743,18.336-3.812,24.805-.153L291.052,230.336c6.469,3.661,5.861,9.655-1.357,13.4Z",
    transform: "translate(251.35 86.057)",
    fill: "#e8e8e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18975",
    "data-name": "Path 18975",
    d: "M158.374,195.426c4.373,2.268,11.105,2.31,15.027.092l125.035-70.625c3.921-2.222,3.554-5.852-.824-8.116l-17.829-9.235c-4.377-2.268-11.111-2.31-15.029-.092L139.715,178.075c-3.919,2.218-3.55,5.852.824,8.12Z",
    transform: "translate(-85.987 106.694)",
    fill: "#e8e8e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17075",
    "data-name": "Group 17075",
    transform: "translate(239.18 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17072",
    "data-name": "Group 17072",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17071",
    "data-name": "Group 17071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17070",
    "data-name": "Group 17070",
    transform: "translate(40.11 207.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18976",
    "data-name": "Path 18976",
    d: "M68.686,133.286h-.005V124.1l6.6,3.321,11.594-6.7a15.116,15.116,0,0,1,13.674,0l116.515,67.272,6.638-3.237v9.083l0,0c.148,1.533-.779,3.091-2.8,4.262l-15.385,8.886a15.143,15.143,0,0,1-13.671,0L71.494,137.5C69.491,136.341,68.561,134.8,68.686,133.286Z",
    transform: "translate(-68.664 -109.386)",
    fill: "#55c3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18977",
    "data-name": "Path 18977",
    d: "M86.873,152.452l6.638-3.237V158.3l0,0c.148,1.533-.779,3.091-2.8,4.262L75.32,171.443a13.948,13.948,0,0,1-6.645,1.62V141.944Z",
    transform: "translate(61.526 -73.845)",
    fill: "#179ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18978",
    "data-name": "Path 18978",
    d: "M205.517,203.178a15.1,15.1,0,0,1-13.671,0L71.5,133.7c-3.774-2.184-3.774-5.715,0-7.895l15.38-8.881a15.1,15.1,0,0,1,13.674,0L220.9,186.4c3.771,2.182,3.771,5.715,0,7.9Z",
    transform: "translate(-68.671 -115.289)",
    fill: "#97dfff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18979",
    "data-name": "Path 18979",
    d: "M49.785,38.87l7.874-4.494a2.072,2.072,0,0,1,.537-.307l.005,0h0a3.31,3.31,0,0,1,2.81.452L287.493,165.279a9.719,9.719,0,0,1,4.4,7.616V346.818a3.09,3.09,0,0,1-1.285,2.846,2.354,2.354,0,0,1-.368.166l-7.833,4.5-1.627-8.474,2.335.973L61.011,218.6a9.726,9.726,0,0,1-4.4-7.619V43.609Z",
    transform: "translate(-48.469 -33.918)",
    fill: "#35afe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18980",
    "data-name": "Path 18980",
    d: "M58.3,34.376a2.071,2.071,0,0,1,.537-.307l.005,0h0a3.31,3.31,0,0,1,2.81.452L288.131,165.279a8.645,8.645,0,0,1,2.767,2.762L139.5,263.547,61.649,218.6a9.726,9.726,0,0,1-4.4-7.619V43.609L50.423,38.87Z",
    transform: "translate(-49.107 -33.918)",
    fill: "#97dfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18981",
    "data-name": "Path 18981",
    d: "M52.972,212.8a9.723,9.723,0,0,0,4.4,7.619L283.853,351.177c2.43,1.4,4.4.266,4.4-2.537V174.715a9.723,9.723,0,0,0-4.4-7.619L57.369,36.338c-2.427-1.4-4.4-.266-4.4,2.537Z",
    transform: "translate(-52.972 -31.09)",
    fill: "#55c3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18982",
    "data-name": "Path 18982",
    d: "M54.642,195.335,281.38,326.241V169.681L54.642,38.776Z",
    transform: "translate(-50.369 -26.365)",
    fill: "#f0fbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18983",
    "data-name": "Path 18983",
    d: "M56.862,40.057V193.609L281.38,323.233v3.009L54.642,195.335V38.776Z",
    transform: "translate(-50.369 -26.365)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17074",
    "data-name": "Group 17074",
    transform: "translate(107.469 99.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17073",
    "data-name": "Group 17073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18984",
    "data-name": "Path 18984",
    d: "M76.288,76.732l68.241,39.4v-3.91l-68.241-39.4Z",
    transform: "translate(-76.288 -72.821)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18985",
    "data-name": "Path 18985",
    d: "M61.287,79.464,167.852,140.99v-3.909L61.287,75.555Z",
    transform: "translate(-61.287 -68.571)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18986",
    "data-name": "Path 18986",
    d: "M61.287,82.2l106.565,61.525v-3.91L61.287,78.289Z",
    transform: "translate(-61.287 -64.32)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18987",
    "data-name": "Path 18987",
    d: "M61.287,84.932l106.565,61.525v-3.909L61.287,81.022Z",
    transform: "translate(-61.287 -60.07)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18988",
    "data-name": "Path 18988",
    d: "M61.287,87.665,167.852,149.19v-3.908L61.287,83.756Z",
    transform: "translate(-61.287 -55.819)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18989",
    "data-name": "Path 18989",
    d: "M61.287,90.4l106.565,61.525v-3.909L61.287,86.489Z",
    transform: "translate(-61.287 -51.569)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18990",
    "data-name": "Path 18990",
    d: "M76.288,95.867l68.241,39.4v-3.911l-68.241-39.4Z",
    transform: "translate(-76.288 -43.069)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18991",
    "data-name": "Path 18991",
    d: "M61.287,98.6l106.565,61.525v-3.909L61.287,94.69Z",
    transform: "translate(-61.287 -38.818)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18992",
    "data-name": "Path 18992",
    d: "M61.287,101.333l106.565,61.525V158.95L61.287,97.423Z",
    transform: "translate(-61.287 -34.568)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18993",
    "data-name": "Path 18993",
    d: "M61.287,104.067l106.565,61.525v-3.911L61.287,100.157Z",
    transform: "translate(-61.287 -30.317)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18994",
    "data-name": "Path 18994",
    d: "M61.287,106.8l106.565,61.525v-3.91L61.287,102.891Z",
    transform: "translate(-61.287 -26.067)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18995",
    "data-name": "Path 18995",
    d: "M61.287,122.068l51.1,29.5v-3.912l-51.1-29.5Z",
    transform: "translate(-5.822 -2.329)",
    fill: "#cbe9f4"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17080",
    "data-name": "Group 17080",
    transform: "translate(17 104.289)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17077",
    "data-name": "Group 17077",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17076",
    "data-name": "Group 17076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18996",
    "data-name": "Path 18996",
    d: "M181.958,200.962l80.85-46.678L278.436,44.139l-15.628-8.931-80.85,46.678Z",
    transform: "translate(-181.958 -35.208)",
    fill: "#144682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18997",
    "data-name": "Path 18997",
    d: "M182.165,197.06l13.563,6.928L274.267,46.343l-14.92-8.526L182.165,82.379Z",
    transform: "translate(-178.14 -33.379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18998",
    "data-name": "Path 18998",
    d: "M181.958,206.212l80.85-46.678V40.459l-80.85,46.678Z",
    transform: "translate(-166.33 -31.528)",
    fill: "#2d5ca0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17079",
    "data-name": "Group 17079",
    transform: "translate(18.218 10.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17078",
    "data-name": "Group 17078"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_18999",
    "data-name": "Path 18999",
    d: "M171.246,207.157,252.1,160.48,267.726,50.335,252.1,41.4,171.246,88.082Z",
    transform: "translate(-171.246 -41.404)",
    fill: "#1890c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19000",
    "data-name": "Path 19000",
    d: "M171.454,203.254l13.563,6.929L263.556,52.539l-14.92-8.526L171.454,88.574Z",
    transform: "translate(-167.429 -39.575)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19001",
    "data-name": "Path 19001",
    d: "M171.246,212.408,252.1,165.73V46.654l-80.85,46.678Z",
    transform: "translate(-155.616 -37.724)",
    fill: "#55c3fe"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19002",
    "data-name": "Path 19002",
    d: "M252.1,165.73V46.654l-80.85,46.678Z",
    transform: "translate(-155.616 -37.724)",
    fill: "#e8e8e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19003",
    "data-name": "Path 19003",
    d: "M179.334,57.278l6.876-3.885V38.761l-3.437,4.882-3.439-2.262Z",
    transform: "translate(-154.084 -12.458)",
    fill: "#ffb347"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17081",
    "data-name": "Group 17081",
    transform: "translate(260.156 103.204)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19004",
    "data-name": "Path 19004",
    d: "M128,89.256a3.381,3.381,0,0,1-.406.782C127.382,90.189,127.729,89.657,128,89.256Z",
    transform: "translate(-104.173 -51.079)",
    fill: "#bcbcbc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19005",
    "data-name": "Path 19005",
    d: "M111.819,112.094c-1.937-2.287-3.482-7.552,3.817-10.682S124.8,95.8,124.8,95.8a16.771,16.771,0,0,1,3.334,5.329,1.6,1.6,0,0,1-1.229,2.126l-.005,0a5.568,5.568,0,0,1,1.16.557,7.171,7.171,0,0,0,.526-1.111c1.952-5.465.728-16.745.728-16.745s.529.1,1.293.286a4.346,4.346,0,0,0,.24-2.992l-.013-.061-1.106-.927.8-.8c-.294-2.031-.37-3.84-.37-3.84l4.939-1.8a4.83,4.83,0,0,1,.976.1l.743-.743,1.931-.858-.644,2.021-1.239,1.436c.278-.1.478.337.508,1.569.043,1.763.432,3.4-1.1,4.813a6.882,6.882,0,0,0-1.571,3.528,4.155,4.155,0,0,1,1.571,1.244c-2.243,8.431-.682,19.966-2.187,23.436-.141.181-.363.475-.672.889a13.985,13.985,0,0,1-.455,6.576,3.453,3.453,0,0,1-3.528.4l13.957,6.185a41.174,41.174,0,0,1,5.214,2.448l8.937-15.82,20.73,11.709-6.653,11.781c.176.4,2.494,6.035-1.579,13.487a4.473,4.473,0,0,1,1.035.989c-3.988,14.105-10.644,19.093-15.14,19.317a95.793,95.793,0,0,1,2.708,9.926c-.544.273-1.083.526-1.622.774,1.336,8.888,3.245,21.029,4.331,25.418.166.659-.059,15.209-.232,27.715-.015,1.137-16.865,17.309-16.88,18.4l-7.353.784,14.954-24.545-2.992-15.958c-.4-.945-1.2-2.43-2.192-4.167.013,1.566-.664,8.513-1.459,16.29-.422,4.18-21.686,15.4-22.554,16.883H114.8c0-1.635,20.792-17.248,20.488-22.608-.273-4.864-.48-8.423-.516-8.758-1.088-10.191-10.434-18.972-10.989-21.139a32.3,32.3,0,0,1-.874-7.023,20.585,20.585,0,0,1-3.321-1.576s1.377-12.072,3.641-16.223.3-12.8-2.665-20.166-1.288-18.574,1.007-19.5c.243-.1.5-.187.766-.266,1.147-1.073-9.785-3.48-7.136-6.106C112.951,115.779,110.66,113.058,111.819,112.094Zm24.46-31.724c.187-.577-.23-1.349.148-2.092L135.283,79.6C135.48,80.294,136.142,80.8,136.28,80.371Zm29.476,67.617s-.043-.376-.079-.933l-.434.766C165.393,147.87,165.564,147.924,165.755,147.988Zm-8.081,10.692c1.162,1.022,3.457-3.247,5.087-6.77l-5.718-3.229C156.157,152.742,155.881,157.1,157.674,158.68Z",
    transform: "translate(-110.21 -74.313)",
    fill: "#e8e8e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17088",
    "data-name": "Group 17088",
    transform: "translate(164.661 102.348)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17082",
    "data-name": "Group 17082",
    transform: "translate(86.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19006",
    "data-name": "Path 19006",
    d: "M126.43,85.608s1.247-.989.687-3.607a39.957,39.957,0,0,1-.687-5.628l4.941-1.806s1.076,0,1.18.215a10.738,10.738,0,0,1-.966,2.749c-.429.989.772,2.192.966,1.592s-.276-1.418.194-2.192.858-.6.9,1.16.432,3.393-1.1,4.813-1.781,4.982-1.781,4.982Z",
    transform: "translate(-98.48 -73.064)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19007",
    "data-name": "Path 19007",
    d: "M126.889,118.736s18.316-16.918,20.265-22.383S154,78.535,154,78.535s5.731,1.068,6.965,2.969c-2.591,9.742-8.275,25.066-8.768,25.421s2.1-3.089-.493.355-12.353,16.395-13.341,16.75S126.889,118.736,126.889,118.736Z",
    transform: "translate(-126.889 -66.892)",
    fill: "#ea902f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19008",
    "data-name": "Path 19008",
    d: "M133.01,74.837l-7.088,7.089,1.89,1.588L134.3,76l.645-2.019Z",
    transform: "translate(-98.399 -73.978)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17087",
    "data-name": "Group 17087",
    transform: "translate(0 22.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19009",
    "data-name": "Path 19009",
    d: "M157.486,160.892c-8.9,5.138-23.316,5.138-32.212,0s-8.9-13.462,0-18.594,23.316-5.133,32.212,0S166.382,155.759,157.486,160.892Z",
    transform: "translate(-22.036 3.708)",
    fill: "#e8e8e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17083",
    "data-name": "Group 17083",
    transform: "translate(0 162.956)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19010",
    "data-name": "Path 19010",
    d: "M151.721,154.358c17.943-10.357,47.03-10.357,64.973,0s17.945,27.151,0,37.5c-1,.583-2.057,1.119-3.13,1.635a29.732,29.732,0,0,1,8.909,3.224c9.287,5.358,9.287,14.054,0,19.414s-24.345,5.363-33.632,0c-7.762-4.479-9.014-11.28-3.8-16.525-12.031.125-24.133-2.445-33.316-7.749C133.778,181.508,133.776,164.71,151.721,154.358Z",
    transform: "translate(-138.263 -146.59)",
    fill: "#e8e8e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19011",
    "data-name": "Path 19011",
    d: "M99.192,177.135c9.287-5.363,24.345-5.363,33.632,0a16.348,16.348,0,0,1,5,4.256c.036-.02.069-.043.1-.064,17.943-10.357,47.03-10.357,64.973,0s17.945,27.151,0,37.5-47.03,10.363-64.973,0c-9.157-5.283-13.628-12.243-13.441-19.172-8.487,1.87-18.451.841-25.293-3.112C89.905,191.189,89.9,182.492,99.192,177.135Z",
    transform: "translate(-6.85 -105.349)",
    fill: "#e8e8e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17086",
    "data-name": "Group 17086",
    transform: "translate(84.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19012",
    "data-name": "Path 19012",
    d: "M122.107,144.93s-.526,4.019-.163,4.939,2.517.728,3.324.5c2.649-.749,9.019-3.906,8.858-6.528-.064-1.068-1.676-.961-4.272.248s-4.062,1.009-4.4.253S122.107,144.93,122.107,144.93Z",
    transform: "translate(-84.5 10.951)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19013",
    "data-name": "Path 19013",
    d: "M129.381,144.188s-.521,4.021-.158,4.939,2.514.728,3.324.5c2.644-.751,9.019-3.906,8.858-6.528-.066-1.068-1.676-.968-4.272.248s-4.065,1-4.4.253S129.381,144.188,129.381,144.188Z",
    transform: "translate(-110.373 9.794)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17085",
    "data-name": "Group 17085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17084",
    "data-name": "Group 17084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19014",
    "data-name": "Path 19014",
    d: "M144.547,191.362c-.243-3.556-2.138-38.543-2.259-39.634-1.086-10.191-10.434-18.972-10.988-21.139-2.016-7.884,0-18.495,0-18.495l18.405.769a182.623,182.623,0,0,1,4.476,37.053c.036,3.689-3.83,37.689-3.86,41.282Z",
    transform: "translate(-126.495 -37.268)",
    fill: "#005b9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19015",
    "data-name": "Path 19015",
    d: "M141.126,154.089c-1.571-3.671-9.1-15.454-10.674-18.914C123.06,121.221,124.81,113,124.81,113l22.994-.91s4.034,28.357,5.825,35.594c.289,1.152-.611,44.718-.365,45.671l-4.688.447Z",
    transform: "translate(-111.247 -37.268)",
    fill: "#005b9a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6793",
    "data-name": "Rectangle 6793",
    width: 23.811,
    height: 31.284,
    transform: "translate(43.918 55.969) rotate(-150.543)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6794",
    "data-name": "Rectangle 6794",
    width: 23.064,
    height: 30.421,
    transform: "translate(43.828 55.328) rotate(-150.544)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19016",
    "data-name": "Path 19016",
    d: "M139.523,85.866a5.6,5.6,0,0,1,6.247,2.108,3.058,3.058,0,0,1,.715,1.709,8.081,8.081,0,0,0,1.975,3.807c1.643,2.006,1.4,6.535.542,8.991a3.45,3.45,0,0,1-3.528.4l.736,6.16-11.9-1.418s1.331-3.01-1.556-7.721-3.352-7.4-.618-10.258,7.389-3.776,7.389-3.776",
    transform: "translate(-121.765 -78.454)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19017",
    "data-name": "Path 19017",
    d: "M147.015,82.807s-1.868,2.486-9.167,5.613-5.754,8.4-3.817,10.684c-1.926,1.6,5.669,8.045,6.758,11.2a9.867,9.867,0,0,0,7.353-3.068,7.219,7.219,0,0,0-1.257-5.488c-1.919-2.468-1.111-5.794.263-5.427.3.084,2.174,4.394,2.379,4.374a2.251,2.251,0,0,0,.554-.194c.309-.186-.508-1.175-.823-3.209-.148-.971.383-3.306.143-3.8a20.341,20.341,0,0,0-1.793-2.407l1.51-.828a1.6,1.6,0,0,0,1.231-2.123,16.821,16.821,0,0,0-3.334-5.329",
    transform: "translate(-127.942 -82.807)",
    fill: "#70380f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19018",
    "data-name": "Path 19018",
    d: "M163.024,104.56s-4.348-5.125-13.423-8.508a44.055,44.055,0,0,0-9.077-2.144s-8.168-.828-12.215.8c-2.294.922-3.968,12.125-1.007,19.5s4.926,16.011,2.662,20.166-3.641,16.223-3.641,16.223a30.823,30.823,0,0,0,10.01,3.475s2.087-10.843,2.358-10.843c.143,0,1.088,11.51,1.088,11.51a43.99,43.99,0,0,0,25.6-4.635c-.968-5.457-4.9-16.019-5.94-21.111s3.579-24.43,3.579-24.43",
    transform: "translate(-125.713 -65.872)",
    fill: "#ffb347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19019",
    "data-name": "Path 19019",
    d: "M121.223,110.152a19.572,19.572,0,0,1,0-4.512,3.988,3.988,0,0,0-.789-3.321c-.432-.618.307-2.279,1.661-.8a6.2,6.2,0,0,1,1.538,3.219l3.441-6.091s2.879,6.2-2.006,14.338C121.872,114.628,121.223,110.152,121.223,110.152Z",
    transform: "translate(-74.441 -58.178)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19020",
    "data-name": "Path 19020",
    d: "M132.392,108.8A9.356,9.356,0,0,0,130.1,99a7.455,7.455,0,0,0-1.878-1.326c-4.254-2.1-7.187,1.5-7.355,9.228s.641,19.029,5.1,26.205c2.726,4.126,13.615,2.315,19.228-17.524-1.421-2.013-6.479-3.367-6.479-3.367s-5.01,12.731-6.926,11.047c-2.5-2.2-.986-9.8.608-14.468",
    transform: "translate(-93.081 -60.602)",
    fill: "#ea902f"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17089",
    "data-name": "Group 17089",
    transform: "translate(251.494 322.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19021",
    "data-name": "Path 19021",
    d: "M161.432,162.913v38.139L156.768,211.1,139.36,213.8l-12.745-7.359V168.3Z",
    transform: "translate(-126.614 -155.556)",
    fill: "#55c3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19022",
    "data-name": "Path 19022",
    d: "M126.614,165.088l14.059-2.175v38.139L136.009,211.1l-9.394,1.455Z",
    transform: "translate(-105.855 -155.556)",
    fill: "#098eb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19023",
    "data-name": "Path 19023",
    d: "M145.848,166.848v38.137l-17.408,2.695V169.541Z",
    transform: "translate(-115.695 -149.438)",
    fill: "#179ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19024",
    "data-name": "Path 19024",
    d: "M148.688,160.033l-17.41,2.693-4.664,10.051,12.745,7.359,17.408-2.693,4.664-10.052Z",
    transform: "translate(-126.614 -160.033)",
    fill: "#97dfff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17096",
    "data-name": "Group 17096",
    transform: "translate(289.51 278.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17090",
    "data-name": "Group 17090",
    transform: "translate(13.485 47.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19025",
    "data-name": "Path 19025",
    d: "M105.227,179.438a25.711,25.711,0,0,0-.7,5.174c.181,1.219.828,3.344,5.909,2.537s12.626-2.982,13.725-5.166-2.468-3.263-7.442-1.727a6.5,6.5,0,0,1-5.358-1.05Z",
    transform: "translate(-84.54 -133.62)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19026",
    "data-name": "Path 19026",
    d: "M108.521,171.708c9.841-5.8,26.039-14.241,28.165-8.342,3.079,8.543.038,43.959.038,43.959s-4.435,2.7-8.569.462c-.682-14.123-1.132-30.684-1.132-30.684s-8.625,10.2-18.5,13.888Z",
    transform: "translate(-108.521 -161.363)",
    fill: "#07599a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17091",
    "data-name": "Group 17091",
    transform: "translate(2.872 67.575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19027",
    "data-name": "Path 19027",
    d: "M145.428,172.216v38.139L140.764,220.4,123.356,223.1l-12.745-7.359V177.6Z",
    transform: "translate(-110.61 -164.859)",
    fill: "#55c3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19028",
    "data-name": "Path 19028",
    d: "M110.61,174.391l14.059-2.175v38.139L120,220.4l-9.395,1.455Z",
    transform: "translate(-89.851 -164.859)",
    fill: "#098eb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19029",
    "data-name": "Path 19029",
    d: "M129.844,176.151v38.137l-17.408,2.695V178.844Z",
    transform: "translate(-99.69 -158.741)",
    fill: "#179ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19030",
    "data-name": "Path 19030",
    d: "M132.684,169.336l-17.41,2.693L110.61,182.08l12.745,7.359,17.408-2.693,4.664-10.052Z",
    transform: "translate(-110.61 -169.336)",
    fill: "#97dfff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17095",
    "data-name": "Group 17095",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19031",
    "data-name": "Path 19031",
    d: "M148.3,163.9l-23.2,28.146-12.36-3.574-12.063-14.534,18.467-26.924,12.449,11.078Z",
    transform: "translate(-85.221 -136.473)",
    fill: "#e6f7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19032",
    "data-name": "Path 19032",
    d: "M136.236,157.156l-23.2,28.146-12.36-3.574,18.853-30.38Z",
    transform: "translate(-73.159 -129.731)",
    fill: "#dfecf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19033",
    "data-name": "Path 19033",
    d: "M104.511,174.238a27.5,27.5,0,0,0,.907,4.829c.48,1.024,1.579,2.711,5.309.363s8.993-6.7,9.236-8.991-2.838-2.113-6.277.843a4.8,4.8,0,0,1-4.466.784Z",
    transform: "translate(-66.703 -102.482)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17092",
    "data-name": "Group 17092",
    transform: "translate(2.759 58.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19034",
    "data-name": "Path 19034",
    d: "M99.722,183.668a25.73,25.73,0,0,0-1.111,5.1c.084,1.229.557,3.4,5.687,3s12.823-1.967,14.093-4.055-2.2-3.449-7.281-2.315a6.5,6.5,0,0,1-5.255-1.474Z",
    transform: "translate(-53.054 -138.271)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19035",
    "data-name": "Path 19035",
    d: "M122.473,178.354s34.258-18.9,36.647-10.135-3.462,43.824-3.462,43.824-4.637,2.338-8.579-.222c.445-14.134,1.316-30.676,1.316-30.676s-13.628,13.74-25.748,13.191-27.232-11.622-18.584-25.643C114.295,167.933,122.473,178.354,122.473,178.354Z",
    transform: "translate(-101.509 -165.899)",
    fill: "#005b9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17094",
    "data-name": "Group 17094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19036",
    "data-name": "Path 19036",
    d: "M128.289,155.268s7.4,2.6,10.127,9.609S144.28,186.5,144.28,186.5l.93,4.949s4.042,17.422-23.392,11.551c-11.073-2.374-7.2-4.425-7.46-6.242s.074-6.247-1.007-14.036-3.6-33.936,10.585-31.732C130.815,153.191,128.289,155.268,128.289,155.268Z",
    transform: "translate(-112.463 -130.498)",
    fill: "#ffb347"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17093",
    "data-name": "Group 17093",
    transform: "translate(9.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19037",
    "data-name": "Path 19037",
    d: "M130.048,146.686s.031.064.084.184a8.17,8.17,0,0,1,.708,4.622c-.488,2.261,1.832,3.217,1.832,3.217s.6.6-.5.953a9.53,9.53,0,0,0-1.61.639,39.185,39.185,0,0,1-1.311,5.015c-.419.71-2.389.59-4.037.608s-3.02,2.729-3.176,4.182c-4.788-1.093-8.572-5.237-8.572-5.237l1.558-3.779S120.917,140.207,130.048,146.686Z",
    transform: "translate(-111.705 -139.282)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19038",
    "data-name": "Path 19038",
    d: "M116.834,146.559c1.41-4.026,6.17-3.641,8.239-3.671.95-.015,1.221.749,2.432.6,1.413,2.747,1.382,4.187,3.753,6.142-.652.815,1.837,1.418,1.837,1.418s-4.09-1.553-3.3,1.047-2.195,7.384-2.195,7.384l-1.206.869a6.95,6.95,0,0,1,.255-2.545c.705-3.245-3.181-2.384-3.449-.664a45.053,45.053,0,0,1-2.092,6.142s-1.5.708-4-1.078C112.917,159.458,114.307,149.936,116.834,146.559Z",
    transform: "translate(-114.436 -142.887)",
    fill: "#333"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_19039",
    "data-name": "Path 19039",
    d: "M113,168.242s1.975,12.866,3.086,14.279c2.537-2.89,14.473-13.566,17.363-15.891l0-.066a17.628,17.628,0,0,1,.8-4.029,3.635,3.635,0,0,0-.12-3.107c-.276-.628.674-1.983,1.625-.424a5.67,5.67,0,0,1,.8,3.15l4.152-4.834s1.385,5.754-3.927,11.985l.026.031s-6.765,9.338-12.069,15.012-8.776,9.7-13.344,7.036-7.774-18.852-7.774-18.852Z",
    transform: "translate(-85.303 -120.445)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19040",
    "data-name": "Path 19040",
    d: "M130.254,173.692s-3.025-13.7-4.724-16.482-8.8-3.577-11.229,2.34,3.973,17.751,3.973,17.751Z",
    transform: "translate(-100.586 -123.908)",
    fill: "#ea902f"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17097",
    "data-name": "Group 17097",
    transform: "translate(210.605 298.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19041",
    "data-name": "Path 19041",
    d: "M177.436,153.61V191.75L172.772,201.8l-17.408,2.695-12.745-7.359V159Z",
    transform: "translate(-142.618 -146.253)",
    fill: "#55c3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19042",
    "data-name": "Path 19042",
    d: "M142.618,155.785l14.059-2.175V191.75L152.013,201.8l-9.395,1.455Z",
    transform: "translate(-121.859 -146.253)",
    fill: "#098eb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19043",
    "data-name": "Path 19043",
    d: "M161.853,157.545v38.137l-17.408,2.695V160.238Z",
    transform: "translate(-131.699 -140.135)",
    fill: "#179ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19044",
    "data-name": "Path 19044",
    d: "M164.693,150.73l-17.41,2.693-4.664,10.051,12.745,7.359,17.408-2.693,4.664-10.052Z",
    transform: "translate(-142.618 -150.73)",
    fill: "#97dfff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17098",
    "data-name": "Group 17098",
    transform: "translate(298.583 277.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19045",
    "data-name": "Path 19045",
    d: "M110.869,145.68s8.043-2.414,12.777,0-.447,6.075-11.972,8.219C116.093,152.049,115.605,145.769,110.869,145.68Z",
    transform: "translate(-97.437 -139.579)",
    fill: "#ea902f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19046",
    "data-name": "Path 19046",
    d: "M133.61,154.231s-3.316,5.087-17.447,2.345c-2.754-.608-1.824-2.859-1.962-4.169s-1.676-9.7,8.807-9.767S134.573,150.457,133.61,154.231Z",
    transform: "translate(-114.044 -142.639)",
    fill: "#ffb347"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_19047",
    "data-name": "Path 19047",
    d: "M129.975,84.568l-25.438-3.03,59.971-23.473L156.435,97.6,140.184,88.1l-6.2,7.661Z",
    transform: "translate(45.638 107.745)",
    fill: "#e8e8e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19048",
    "data-name": "Path 19048",
    d: "M94.032,110.862l-37.938-4.519L125.88,79.029l16.178,9.341L133.494,130.3l-24.237-14.177L100,127.552Z",
    transform: "translate(324.423 36.224)",
    fill: "#e8e8e8",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17099",
    "data-name": "Group 17099",
    transform: "translate(380.769 8.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19049",
    "data-name": "Path 19049",
    d: "M163.038,37.166l-120.6,47.2,52,6.193Z",
    transform: "translate(-42.44 -37.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19050",
    "data-name": "Path 19050",
    d: "M42.44,90.46l8.052,22.506,61.393-75.8Z",
    transform: "translate(8.713 -37.166)",
    fill: "#97dfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19051",
    "data-name": "Path 19051",
    d: "M51.633,95.638,42.44,112.966l61.393-75.8Z",
    transform: "translate(16.765 -37.166)",
    fill: "#55c3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19052",
    "data-name": "Path 19052",
    d: "M94.64,37.166,78.4,116.675,42.44,95.638Z",
    transform: "translate(25.958 -37.166)",
    fill: "#fff"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17100",
    "data-name": "Group 17100",
    transform: "translate(131.176 35.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19053",
    "data-name": "Path 19053",
    d: "M183.974,41.752,104.538,72.843l34.25,4.079Z",
    transform: "translate(-104.538 -41.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19054",
    "data-name": "Path 19054",
    d: "M104.538,76.856l5.3,14.823,40.439-49.928Z",
    transform: "translate(-70.844 -41.752)",
    fill: "#97dfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19055",
    "data-name": "Path 19055",
    d: "M110.594,80.266l-6.056,11.413,40.439-49.928Z",
    transform: "translate(-65.541 -41.752)",
    fill: "#55c3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19056",
    "data-name": "Path 19056",
    d: "M138.92,41.752,128.226,94.123,104.538,80.266Z",
    transform: "translate(-59.485 -41.752)",
    fill: "#fff"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17103",
    "data-name": "Group 17103",
    transform: "translate(68.762 160.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19057",
    "data-name": "Path 19057",
    d: "M257.078,78.15,253.825,76.3a.868.868,0,0,0-.219-.126h0a1.364,1.364,0,0,0-1.161.185l-93.523,54A4.01,4.01,0,0,0,157.1,133.5v71.819a1.277,1.277,0,0,0,.53,1.176,1.012,1.012,0,0,0,.152.068l3.234,1.86.673-3.5-.966.4,91.715-52.951a4.015,4.015,0,0,0,1.818-3.146V80.109Z",
    transform: "translate(-157.104 -76.107)",
    fill: "#35afe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19058",
    "data-name": "Path 19058",
    d: "M253.151,76.3a.868.868,0,0,0-.219-.126h0a1.364,1.364,0,0,0-1.161.185l-93.523,54a3.569,3.569,0,0,0-1.141,1.139l62.517,39.438,32.148-18.561a4.015,4.015,0,0,0,1.818-3.146V80.109l2.819-1.959Z",
    transform: "translate(-156.431 -76.107)",
    fill: "#97dfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19059",
    "data-name": "Path 19059",
    d: "M253.962,150.271a4.012,4.012,0,0,1-1.814,3.146l-93.524,54c-1,.576-1.816.11-1.816-1.048V134.544a4.01,4.01,0,0,1,1.816-3.144l93.524-54c1-.58,1.814-.11,1.814,1.048Z",
    transform: "translate(-153.446 -75.237)",
    fill: "#55c3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19060",
    "data-name": "Path 19060",
    d: "M251.4,143.558l-93.628,54.055V132.965L251.4,78.909Z",
    transform: "translate(-152.648 -73.784)",
    fill: "#e6f7ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17102",
    "data-name": "Group 17102",
    transform: "translate(46.108 24.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17101",
    "data-name": "Group 17101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19061",
    "data-name": "Path 19061",
    d: "M190.7,91.317l-28.332,16.357v-1.624L190.7,89.694Z",
    transform: "translate(-146.455 -89.694)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19062",
    "data-name": "Path 19062",
    d: "M206.608,92.9l-44.242,25.544v-1.623L206.608,91.28Z",
    transform: "translate(-162.366 -88.38)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19063",
    "data-name": "Path 19063",
    d: "M206.608,94.488l-44.242,25.544v-1.624l44.242-25.543Z",
    transform: "translate(-162.366 -87.066)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19064",
    "data-name": "Path 19064",
    d: "M206.608,96.073l-44.242,25.544v-1.623L206.608,94.45Z",
    transform: "translate(-162.366 -85.752)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19065",
    "data-name": "Path 19065",
    d: "M206.608,97.659,162.366,123.2V121.58l44.242-25.544Z",
    transform: "translate(-162.366 -84.437)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19066",
    "data-name": "Path 19066",
    d: "M206.608,99.244l-44.242,25.544v-1.623l44.242-25.544Z",
    transform: "translate(-162.366 -83.123)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19067",
    "data-name": "Path 19067",
    d: "M190.7,102.415l-28.332,16.357v-1.624L190.7,100.792Z",
    transform: "translate(-146.455 -80.495)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19068",
    "data-name": "Path 19068",
    d: "M206.608,104l-44.242,25.543v-1.623l44.242-25.544Z",
    transform: "translate(-162.366 -79.181)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19069",
    "data-name": "Path 19069",
    d: "M206.608,105.586l-44.242,25.543v-1.623l44.242-25.544Z",
    transform: "translate(-162.366 -77.867)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19070",
    "data-name": "Path 19070",
    d: "M206.608,107.171l-44.242,25.543v-1.623l44.242-25.543Z",
    transform: "translate(-162.366 -76.552)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19071",
    "data-name": "Path 19071",
    d: "M206.608,108.757,162.366,134.3v-1.624l44.242-25.543Z",
    transform: "translate(-162.366 -75.238)",
    fill: "#cbe9f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19072",
    "data-name": "Path 19072",
    d: "M196.171,117.611,174.956,129.86v-1.624l21.215-12.249Z",
    transform: "translate(-174.956 -67.898)",
    fill: "#cbe9f4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_19073",
    "data-name": "Path 19073",
    d: "M250.484,79.438v63.408l-92.711,53.525v1.241L251.4,143.558V78.909Z",
    transform: "translate(-152.648 -73.784)",
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_17110",
    "data-name": "Group 17110",
    transform: "translate(159.659 205.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17104",
    "data-name": "Group 17104",
    transform: "translate(13.485 47.876)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19074",
    "data-name": "Path 19074",
    d: "M156.052,151.143a25.713,25.713,0,0,0-.7,5.174c.181,1.219.828,3.344,5.909,2.537s12.626-2.982,13.725-5.166-2.468-3.26-7.442-1.727a6.494,6.494,0,0,1-5.358-1.048Z",
    transform: "translate(-135.365 -105.326)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19075",
    "data-name": "Path 19075",
    d: "M159.346,143.415c9.841-5.8,26.039-14.238,28.165-8.342,3.079,8.543.038,43.962.038,43.962s-4.438,2.7-8.569.46c-.682-14.123-1.132-30.684-1.132-30.684s-8.628,10.2-18.5,13.891Z",
    transform: "translate(-159.346 -133.07)",
    fill: "#04467c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17105",
    "data-name": "Group 17105",
    transform: "translate(10.058 69.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19076",
    "data-name": "Path 19076",
    d: "M193.441,144.307v38.139L188.776,192.5l-17.408,2.695-12.745-7.359V149.694Z",
    transform: "translate(-158.623 -136.95)",
    fill: "#55c3fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19077",
    "data-name": "Path 19077",
    d: "M158.623,146.482l14.059-2.175v38.139L168.017,192.5l-9.395,1.455Z",
    transform: "translate(-137.863 -136.95)",
    fill: "#098eb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19078",
    "data-name": "Path 19078",
    d: "M177.857,148.242v38.137l-17.408,2.695V150.935Z",
    transform: "translate(-147.703 -130.832)",
    fill: "#179ecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19079",
    "data-name": "Path 19079",
    d: "M180.7,141.428l-17.41,2.693-4.665,10.051,12.745,7.359,17.408-2.693,4.664-10.052Z",
    transform: "translate(-158.623 -141.428)",
    fill: "#97dfff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17109",
    "data-name": "Group 17109",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19080",
    "data-name": "Path 19080",
    d: "M193.268,143.053l-33.807,13.7L145.661,141l30.559-13.658Z",
    transform: "translate(-115.277 -94.098)",
    fill: "#dfecf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19081",
    "data-name": "Path 19081",
    d: "M155.336,145.945a27.452,27.452,0,0,0,.9,4.831c.48,1.025,1.581,2.708,5.312.36s8.991-6.7,9.233-8.991-2.836-2.113-6.277.846a4.8,4.8,0,0,1-4.466.784Z",
    transform: "translate(-117.526 -73.517)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17106",
    "data-name": "Group 17106",
    transform: "translate(2.759 59.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19082",
    "data-name": "Path 19082",
    d: "M150.547,155.375a25.733,25.733,0,0,0-1.111,5.1c.084,1.232.557,3.4,5.687,3s12.823-1.967,14.093-4.057-2.2-3.449-7.281-2.315a6.5,6.5,0,0,1-5.258-1.472Z",
    transform: "translate(-103.879 -109.978)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19083",
    "data-name": "Path 19083",
    d: "M173.3,150.061s34.261-18.9,36.65-10.135-3.462,43.824-3.462,43.824-4.637,2.34-8.579-.22c.445-14.134,1.316-30.679,1.316-30.679s-13.63,13.74-25.748,13.191S146.239,154.42,154.887,140.4C165.12,139.64,173.3,150.061,173.3,150.061Z",
    transform: "translate(-152.334 -137.606)",
    fill: "#005b9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17108",
    "data-name": "Group 17108",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19084",
    "data-name": "Path 19084",
    d: "M179.157,126.976s7.4,2.6,10.128,9.606,5.861,21.622,5.861,21.622l.933,4.946s3.007,22.47-24.427,16.6c-11.073-2.371-7.128-8.073-7.386-9.887s1.035-7.647-.046-15.436-3.6-33.936,10.585-31.729C181.684,124.9,179.157,126.976,179.157,126.976Z",
    transform: "translate(-163.332 -101.532)",
    fill: "#f7ffff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17107",
    "data-name": "Group 17107",
    transform: "translate(9.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19085",
    "data-name": "Path 19085",
    d: "M180.871,118.394s.033.061.087.181a8.206,8.206,0,0,1,.708,4.624c-.488,2.259,1.832,3.217,1.832,3.217s.6.6-.5.953a9.643,9.643,0,0,0-1.612.639,38.691,38.691,0,0,1-1.308,5.015c-.416.71-2.391.59-4.037.608s-3.017,2.729-3.173,4.18c-4.79-1.091-8.574-5.235-8.574-5.235l1.558-3.779S171.74,111.915,180.871,118.394Z",
    transform: "translate(-162.531 -110.316)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19086",
    "data-name": "Path 19086",
    d: "M177.311,131.594s2.987-4.788,2.195-7.384,3.3-1.05,3.3-1.05,3.766-3.173,2.644-6.413a2.348,2.348,0,0,1-1.9.48l.751-1.518a29.93,29.93,0,0,1-4.9.25,4.459,4.459,0,0,0,1.556-1.63,61.993,61.993,0,0,1-6.17.674c-2.069.031-6.832-.355-8.239,3.669-2.529,3.378-3.919,12.9.278,15.641,2.5,1.788,4,1.081,4,1.081a45.081,45.081,0,0,0,2.09-6.144c.268-1.719,4.154-2.578,3.449.667a6.936,6.936,0,0,0-.255,2.542Z",
    transform: "translate(-164.144 -114.331)",
    fill: "#333"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_19087",
    "data-name": "Path 19087",
    d: "M161.052,133.94s5.317,12.366,5.618,14.134c3.607-1.329,19.187-5.033,22.835-5.7l.033-.056a17.926,17.926,0,0,1,2.619-3.163,3.634,3.634,0,0,0,1.377-2.79c.056-.682,1.535-1.421,1.63.4a5.656,5.656,0,0,1-.795,3.153l5.955-2.274s-1.525,5.718-9.162,8.669l.005.036s-10.4,4.992-17.761,7.453-12.337,4.351-15.087-.166-8.257-19.818-8.257-19.818Z",
    transform: "translate(-133.584 -84.036)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19088",
    "data-name": "Path 19088",
    d: "M181.527,149.94s-3.74-18.242-5.439-21.022-8.8-3.577-11.231,2.338,3.817,22.34,3.817,22.34Z",
    transform: "translate(-151.144 -94.941)",
    fill: "#edf4f4"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIllustration);
export default __webpack_public_path__ + "static/media/dashboardIllustration.0a5afc68398a77b8765f624c17c1a0b6.svg";
export { ForwardRef as ReactComponent };